import { Grid, List, ListItem, Button } from "@material-ui/core";
import styled from "styled-components";

export const styles = () => ({
  heading: {
    "font-size": "17px;"
  },
  disabledInputStyle: {
    color: "rgba(0, 0, 0, 0.87);",
    "border-bottom": "1px rgba(0, 0, 0, 0)"
  },
  toggleMargin: {
    marginTop: "15px !important",
    marginBottom: "15px !important"

  }
});
export const SelectedNoItemGrid = styled(Grid)`
  &&&& {
        margin-left: 13px;
        padding: 12px;
        background-color: rgb(242, 242, 242);
        font-family: "Roboto Medium", "Roboto Regular", Roboto;
        font-weight: 500;
        font-style: normal;
        font-size: 17px;
        color: rgb(153, 153, 153);
  }`;
export const SelectedListItem = styled(ListItem)`
  border-left: 3px solid rgba(43, 89, 121, 1);  
  &&&&&& {    
    color: #2B5979;
    font-family: 'Roboto Medium', 'Roboto Regular', 'Roboto';
    font-weight: 500;
    font-style: normal;
    font-size: 17px;
  }
  &&:hover {
      background: rgba(245, 245, 245, 1);
  }
`;
export const UnSelectedListItem = styled(ListItem)`
  cursor: pointer;
  border-left: 3px solid rgba(255, 255, 255, 0); 
  &&&&&& {    
    color: #009DDF;
    font-family: 'Roboto Medium', 'Roboto Regular', 'Roboto';
    font-weight: 500;
    font-style: normal;
    font-size: 17px;
  }
  &&:hover {
      background: rgba(245, 245, 245, 1);
  }
`;
export const ItemList = styled(List)`
  &&& {
    padding-top:1px;     
  }
`;

export const SectionTitle = styled.div`
  //Removing to enable custom sizing
  // font-size: 24px;
  padding-top: 7px;
`;
export const SectionFragment = styled.div`
    margin-bottom: 50px;
    margin-top: 25px;

`;
export const SubSectionFragment = styled.div`
    margin-top:25px;
`;

export const ToggleButtonsFragment = styled.div`
    margin-top:-5px;
`;

export const HeaderSection = styled(Grid)`
margin-top: 15px;    
margin-bottom: 15px;
`;
export const Divider = styled.div`
    margin-top: 20px;
`;
export const StyledActionButton = styled(Button)`
    && {        
        margin-left: 4px;
        padding: 8px 8px 8px 2px;
        border-radius: 0;color: #2196f3;
        
        background: none;
    }
    &&:hover {
        background: none;
    }
`;
export const StyledLinkButton = styled(Button)`
    && {        
        margin-left: 4px;
        padding: 8px 8px 8px 2px;
        border-radius: 0;
        color: #999999;
        background: none;
    }
    &&:hover {
        background: none;
    }
`;
export const VerticalDivider = styled.div`
  height: 24px;
  border-right: 1px solid #cccccc;
`;
export const GridValue = styled.div`
  text-align: right;
  padding-right:50px;  
  margin-top:10px;
`;

export const LabelContainerBold = styled.div`    
    font-weight: bold;
    margin-top:10px;
`;
export const DetailsCashFlowContainer = styled(Grid)`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    float:right;
    margin-left: auto;
    margin-right:15px;
`;
